if (!customElements.get('drock-video-controls')) customElements.define('drock-video-controls', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort=new AbortController();
    const options={signal:this.abort.signal};
    const video=this.closest('vault-studio')?.querySelector('video');
    if(!video){this.hidden=true;return;}
    const play=this.querySelector('[data-video-play]'),status=this.querySelector('[data-video-status]');
    const update=()=>{play.textContent=video.paused?'Play video':'Pause video';};
    play.addEventListener('click',async()=>{if(video.paused){try{await video.play();status.textContent='';}catch{status.textContent='Playback is unavailable. Try the video controls.';}}else video.pause();},options);
    this.querySelector('[data-video-fullscreen]').addEventListener('click',async()=>{try{if(video.requestFullscreen)await video.requestFullscreen();else if(video.webkitEnterFullscreen)video.webkitEnterFullscreen();else status.textContent='Use the video controls to expand playback.';}catch{status.textContent='Use the video controls to expand playback.';}},options);
    ['play','pause'].forEach(event=>video.addEventListener(event,update,options));update();
  }
  disconnectedCallback(){this.abort?.abort();}
});
